module.exports = __webpack_public_path__ + "static/media/otp-error.8267517c.svg";